<template>
    <div class="notes several" style="height: 70vh">
        <h4 class="note-title text-truncate" v-b-tooltip.hover >
            <span :class="icon"></span>
            <span> {{this.title}} </span> 
        </h4>

        <b-icon
            icon="x-circle-fill"
            v-on:click="Close"
            class="rounded-circle notes-close"
            scale=".5"
            font-scale="1.8"
            > <!-- create the CloseNote action. Open notes should be closed with the HIDDEN class -->
        </b-icon>

        <iframe id="pdf-iframe" :src="this.PdfBase64" width="100%" height="100%" title="ASAM.pdf" style="height: 100%;" v-if="!loading"></iframe>    
        <div v-else>{{ message }}</div>    
    </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import LocalStorage from '@/services/storage.service'
import Utils from '@/common/utils'
import AsamService from '@/services/asam.service'
import DBFunctions from '@/common/DBFunctions.js'
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
    name: 'AsamAssessmentChartReview',
    mixins: [ShowMessage, DBFunctions],
    props: {
        item: Object,
        reportEvent: Function
    },

    computed: {
        title() {
            return Utils.formatterDateToShortLocaleString(this.item.transDate);
        }
    },

    data: function() {
        return { 
            icon:"ikon med-doc-complete mr-2",
            isReadOnly: true,
            UserId: LocalStorage.getUserId(),
            PdfBase64:'data:application/pdf;base64, ',
            loading: true,
            message: this.$t('Shared.Loading')
        }
    },

    methods: {
        async Close() {   
            this.$emit('remove');
            EventBus.$emit('CloseDocument');
        },

        handlePrint() {
            if (this.reportEvent) {
                this.reportEvent({recId: this.item.seqno, patientId: this.item.patientId, assessmentType: this.item.assessmentTypesId, assessmentId: this.item.assessmentId, cnPatientId: this.item.cnPatientId});
            }
        },

        getReport() {
            var data = {
                "PatientId":this.item.cnPatientId,
                "AssessmentType":this.item.assessmentTypesId,
                "AssessmentId":this.item.assessmentId
            };

            AsamService.getReport(data)
                .then((response) => {
                    if(response.status == '200' && response.data){         
                        var base64report = response.data;
                        this.PdfBase64 += base64report.content;               
                        //this.OpenPdf(base64report.content);     
                    }    
                    EventBus.$emit('ShowWeel', false);  
                    this.loading = false;              
                })
                .catch((error) => {
                    EventBus.$emit('ShowWeel', false);
                    this.message = this.showResponseErrorMessage(error);
                });
        },

        /*OpenPdf(base64) {
            var xwin = window.open();
            var iframepdf = xwin.document.createElement('iframe')
            iframepdf.width = '100%'
            iframepdf.height = '100%'
            xwin.document.title = this.$t('ChartReview.AsamAssessmentReport')
            iframepdf.frameBorder = 0
            iframepdf.style = "border: 0"
            iframepdf.src = "data:application/pdf;base64, " +base64
            xwin.document.body.appendChild(iframepdf);
        },*/
    },

    mounted() {
        EventBus.$emit('ShowWeel', true); 
        this.getReport();
    }

}
</script>